
        import 'BrokerQuote.fd3baa0.css-module'
        export default {"container":"container_BrokerQuote_fd3baa0","rowStructure":"rowStructure_BrokerQuote_fd3baa0","details":"details_BrokerQuote_fd3baa0","subTitle":"subTitle_BrokerQuote_fd3baa0","disabled":"disabled_BrokerQuote_fd3baa0"}
    